import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';

// Sentry client-side error tracking
// Set REACT_APP_SENTRY_DSN in your .env to activate
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn:              import.meta.env.VITE_SENTRY_DSN,
    environment:      import.meta.env.MODE,
    // Capture 100% in dev, 10% of sessions in prod (adjust to your volume)
    tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0,
    replaysSessionSampleRate: 0,   // Session replay off by default (privacy)
    replaysOnErrorSampleRate:  0,  // Replay only on errors: 0 = off
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Sentry.ErrorBoundary
    fallback={({ error, resetError }) => (
      <div style={{
        display:'flex', flexDirection:'column', alignItems:'center',
        justifyContent:'center', minHeight:'100vh', padding:24,
        fontFamily:'system-ui,sans-serif', background:'#FAFAFA',
      }}>
        <div style={{ fontSize:40, marginBottom:16 }}>⚠️</div>
        <div style={{ fontSize:18, fontWeight:700, marginBottom:8, color:'#09090B' }}>
          Something went wrong
        </div>
        <div style={{ fontSize:14, color:'#71717A', marginBottom:24, textAlign:'center', maxWidth:380 }}>
          An unexpected error occurred. Our team has been notified automatically.
        </div>
        <button
          onClick={resetError}
          style={{
            padding:'9px 20px', background:'#2563EB', color:'#fff',
            border:'none', borderRadius:8, cursor:'pointer',
            fontSize:14, fontWeight:600, fontFamily:'inherit',
          }}
        >
          Try again
        </button>
      </div>
    )}
  >
    <App />
  </Sentry.ErrorBoundary>
);
